<template>

  <b-modal
    id="edit-operation-honoraire-modal"
    :ok-title="$t('Validate')"
    :title="$t('Modify') + ' ' + (operationHonoraire.data && operationHonoraire.data.hasOwnProperty('type') ? operationHonoraire.data.type : '')"
    centered
    ok-only
    ok-variant="primary"
    @ok="handleOk">

    <form ref="operationForm" novalidate>
      <div class="my-2 row">
        <div class="col-md-12">
          <AutocompleteField
            v-model="operationHonoraire.data.type"
            :input-class="'medium-label mb-4'"
            :input-id="'type-input'"
            :input-label="$t('operationHonoraire.Type')"
            :items="types"
            :required=true
            :search-input="operationHonoraire.data.type"
            @elementValueChanged="getSelectedValueType">
          </AutocompleteField>
        </div>

        <template v-if="factureValidated || devisValidated">
          <template v-if="devisValidated">
            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t('devis.NumeroDevis') }}</div>
                <div class="prixTTC bold-text">{{ devisValidated.numero }}</div>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`) }}</div>
                <div class="prixTTC bold-text">{{ isHT ? devisValidated.prixHT : devisValidated.prixTTC }}€</div>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t('devis.TauxTVA') }}</div>
                <div class="prixTTC bold-text">{{ devisValidated.tauxTVA }}</div>
              </div>
            </div>

            <div class="col-md-6 mb-4">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t('operationHonoraire.ContactName') }}</div>
                <div class="prixTTC bold-text">{{ devisValidated.artisan.toString }}</div>
              </div>
            </div>


          </template>
          <template v-for="facture in operationHonoraire.data.factures" v-if="factureValidated">
            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t('facture.NumeroFacture') }}</div>
                <div class="prixTTC bold-text">{{ facture.nom }}</div>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`) }}</div>
                <div class="prixTTC bold-text">{{ facture.prixTTC }}€</div>
              </div>
            </div>

            <div class="col-md-6 mb-2">
              <div class="d-flex prixTTCContainer d-flex justify-content-between">
                <div>{{ $t('facture.PrixTVA') }}</div>
                <div class="prixTTC bold-text">{{ facture.prixTVA }}</div>
              </div>
            </div>
            <div class="col-md-6 mb-2">

            </div>

          </template>
          <div class="col-md-6 mb-2">

          </div>
          <div class="col-md-6 mb-2 mt-2">
            <div class="d-flex prixTTCContainer d-flex justify-content-between">
              <div>{{ $t(`operationConstruction.prix${isHT ? 'HT': 'TTC'}`) }}</div>
              <div class="prixTTC bold-text">{{ prixModel }}€</div>
            </div>
          </div>

          <div v-if="!devisValidated" class="col-md-6">
            <AutocompleteField
              v-model="operationHonoraire.data.contactName"
              :input-class="'medium-label mb-2'"
              :input-id="'contact-input'"
              :input-label="$t('operationHonoraire.Contact.Name')"
              :items="contactNames"
              :required=true
              :search-input="operationHonoraire.data.contactName"
              @elementValueChanged="getSelectedValueContact">
            </AutocompleteField>
          </div>
        </template>
        <template v-else>
          <div class="col-md-6">
            <b-form-group
              :label="$t(`operationHonoraire.prix${isHT ? 'HT': 'TTC'}`)"
              :label-for="'prixTTC-input'"
              class="medium-label mb-2">
              <b-input-group
                :id="'prixTTC-input'">
                <b-form-input
                  v-model="prixModel"
                  min="0"
                  required
                  step="any"
                  type="number">
                </b-form-input>
                <b-input-group-append>€</b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <b-form-group
              :label="$t('operationHonoraire.TauxTVA')"
              :label-for="'tauxTVA-input-' + index"
              class="medium-label mb-2">
              <b-form-select
                id="'tauxTVA-input-' + index"
                v-model="operationHonoraire.data.tauxTVA"
                required>
                <option v-for="option in filteredTauxTVAList" :key="option.value" :value="option.value">
                  {{ $t(option.text) }}
                </option>
              </b-form-select>
            </b-form-group>
          </div>

          <div class="col-md-6">
            <AutocompleteField
              v-model="this.operationHonoraire.data.contactName"
              :input-class="'medium-label mb-2'"
              :input-id="'contact-input'"
              :input-label="$t('operationHonoraire.Contact.Name')"
              :items="contactNames"
              :required=true
              :search-input="this.operationHonoraire.data.contactName"
              @elementValueChanged="getSelectedValueContact">
            </AutocompleteField>
          </div>
        </template>


        <div class="col-md-6">
          <b-form-group
            :label="$t('operationHonoraire.date')"
            :label-for="'date-input'"
            :state="operationHonoraire.data.dateState"
            class="medium-label mb-2">
            <datepicker-input
              :id="'date-input'"
              v-model="operationHonoraire.data.date"
              :state="operationHonoraire.data.dateState"
              required
              @change="operationHonoraire.data.dateState=null"
              @input="operationHonoraire.data.dateState=null">
            </datepicker-input>
          </b-form-group>
        </div>

        <div
          v-if="((operationHonoraire.data.operation && operationHonoraire.data.operation.id !== null) || ( operationHonoraire.selectedLots.length !== 0)) "
          class="col-md-12 mt-2">
          <b-form-group
            :label="$t('operationHonoraires.lots.tolink')"
            :label-for="'lots-input'"
            class="medium-label mb-2">

            <div :id="'lots-input'" class="custom-container">
              <template v-for="(operationLot, index) in operationLots">
                <b-form-checkbox
                  :key="operationLot.id + '-' + operationHonoraire.selectedLots.includes(operationLot.id)"
                  :ref="'checkbox' + operationLot.id"
                  :checked="operationHonoraire.selectedLots&&operationHonoraire.selectedLots.includes(operationLot.id)"
                  :disabled="(operationHonoraire.data.hasOwnProperty('factures') && operationHonoraire.data.factures.length > 0) || (operationHonoraire.data.hasOwnProperty('devis')&&operationHonoraire.data.devis.find(devis=>devis.validated === true && devis.id))"
                  @change="handleCheckboxChange(operationLot.id)">
                    <span v-if="operationLot.lotCoPro">{{
                        $t('operation.bilan.Lot') + ' ' + operationLot.lotCoPro
                      }}</span>
                  <span v-else>{{ $t('operation.bilan.Lot') + ' ' + operationLot.lotNumber }}</span>
                </b-form-checkbox>
              </template>
            </div>
          </b-form-group>
        </div>
      </div>


    </form>

  </b-modal>

</template>

<script>

import AutocompleteField from "../../../components/b122/editFields/AutocompleteField";
import DatepickerInput from "../../../components/b122/editFields/DatepickerInput.vue";

export default {

  name: "editOperationHonoraireModal",

  components: {
    AutocompleteField,
    DatepickerInput
  },

  props: {
    operationHonoraire: {
      type: Object,
      required: true,
    },

    types: {
      type: Array,
      default() {
        return []
      }
    },
    operationLots: {
      type: Array,
      default: () => [],
    },
    contactNames: {
      type: Array,
      default: () => [],
    },

    tauxTVAList: {
      type: Array,
      default: () => [],
    },
    isHT: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      devisValidated: false,
      factureValidated: false,
      modalKey: 0,
      selectedDevisIndex: null,
      index: null,
    }
  },

  emits: ['didEditOperationHonoraire'],

  computed: {
    filteredTauxTVAList() {
      if (this.tauxTVAList && this.tauxTVAList.length > 0) {
        return this.tauxTVAList.filter(option => option.value !== this.operationHonoraire.tauxTVA);
      }
      return []
    },
    prixModel: {
      get() {
        return this.isHT ? this.operationHonoraire.data.prixHT : this.operationHonoraire.data.prixTTC
      },
      set(val) {
        if (this.isHT) {
          this.operationHonoraire.data.prixHT = val
        } else {
          this.operationHonoraire.data.prixTTC = val
        }
      }
    }
  },

  mounted() {
    this.selectedLots = this.operationLots.map(lot => lot.id);
    if (this.operationHonoraire && this.operationHonoraire.data && this.operationHonoraire.data.id) {
      this.index = this.operationHonoraire.data.id
      this.manageDevisValidated()
      this.manageFactureValidated()
    }
  },

  watch: {
    'operationHonoraire.data.id': {
      handler: async function (val) {
        this.selectedLots = this.operationLots.map(lot => lot.id);
        this.index = this.operationHonoraire.data.id
        this.manageDevisValidated()
        this.manageFactureValidated()
      },
      deep: true,
    },
    'operationHonoraire.data.devis': {
      handler: async function (val) {
        this.index = this.operationHonoraire.data.id
        this.manageDevisValidated()
        this.manageFactureValidated()
      },
      deep: true,
    }
  },

  methods: {

    getSelectedValueType(data) {
      this.operationHonoraire.data.type = data
    },
    getSelectedValueContact(data) {
      this.operationHonoraire.data.contactName = data
    },

    handleOk($event) {
      const form = this.$refs.operationForm;
      if (!form.reportValidity() || !this.operationHonoraire.data.date) {
        $event.preventDefault();
        if (!this.operationHonoraire.data.date) {
          this.operationHonoraire.data.dateState = false;
        }
        return
      }
      this.handleSubmit();
    },

    handleCheckboxChange(lotId) {
      const index = this.operationHonoraire.selectedLots.indexOf(lotId);
      if (index === -1) {
        this.operationHonoraire.selectedLots.push(lotId);
      } else {
        if (this.operationHonoraire.selectedLots.length > 1) {
          this.operationHonoraire.selectedLots.splice(index, 1);
        } else {
          this.$refs["checkbox" + lotId][0].checked = true;
          this.$refs["checkbox" + lotId][0].computedLocalChecked = true;
          this.$refs["checkbox" + lotId][0].localChecked = true;
        }
      }
    },

    handleSubmit() {
      if (this.operationHonoraire && this.operationHonoraire.data.type && this.operationHonoraire.data.type.trim() !== '' && this.operationHonoraire.data.date && this.operationHonoraire.data.tauxTVA) {
        this.$emit('didEditOperationHonoraire', this.operationHonoraire)
      }
      this.resetModal()
      this.hideModal()
    },

    resetModal() {
      this.operationHonoraire = null
    },

    hideModal() {
      console.log('hide modal')
      this.$bvModal.hide('edit-operation-honoraire-modal')
    },

    manageDevisValidated() {
      let devis = this.operationHonoraire.data.devis
      this.devisValidated = null
      if (devis) {
        devis.forEach((item, index) => {
          if (item.validated) {
            this.devisValidated = item
            this.operationHonoraire.data.tauxTVA = item.tauxTVA
          }
        })
      }
    },

    manageFactureValidated() {
      let factures = this.operationHonoraire.data.factures
      this.factureValidated = null
      if (factures && factures.length > 0) {
        this.factureValidated = true
      }
    },

  }

}

</script>

<style scoped>
.prixTTCContainer {
  padding: 8px 12px;
  background-color: #F4F4F4;
  color: #07153C;
  border: solid 1px #CCCCCC;
}

.prixTTC {
  color: var(--main-color);
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #dc3545;
  padding-right: 0 !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23dc3545' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23dc3545' stroke='none'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}

.grey-text {
  color: #AAAAAA;
}

.custom-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.custom-container > * {
  margin-left: 1em;
}
</style>



// WEBPACK FOOTER //
// src/views/operationBilan/components/EditOperationHonoraireModal.vue